module.exports = __webpack_public_path__ + "img/LEAF-O.307839ed.svg";